<template>
  <div class="form-date">
    <ion-item>
      <ion-input type="month" :value="computedValue" @input="handleInput" />
    </ion-item>
  </div>
</template>

<script>
import { DateTime } from "luxon";

export default {
  name: "FormDate",
  props: {
    value: String,
    properties: Object
  },
  computed: {
    computedValue: {
      get() {
        const date = DateTime.fromISO(this.value);
        if (date.isValid) {
          return date.toFormat("yyyy-dd");
        }
        return undefined;
      },
      set(value) {
        const date = DateTime.fromFormat(value, "yyyy-dd");
        const iso = date.toISODate();
        this.$emit("input", iso);
      }
    }
  },
  methods: {
    handleInput(e) {
      this.computedValue = e.target.value;
    }
  }
};
</script>
